import { CHAIN_ID } from "./chains"

export const GRAPH_API_PROFILE = process.env.REACT_APP_GRAPH_API_PROFILE
export const GRAPH_API_PREDICTION = process.env.REACT_APP_GRAPH_API_PREDICTION
export const GRAPH_API_LOTTERY = process.env.REACT_APP_GRAPH_API_LOTTERY
export const SNAPSHOT_VOTING_API = process.env.REACT_APP_SNAPSHOT_VOTING_API
export const SNAPSHOT_BASE_URL = process.env.REACT_APP_SNAPSHOT_BASE_URL
export const API_PROFILE = process.env.REACT_APP_API_PROFILE
export const API_NFT = "https://test-api.shimmersea.finance/api/v1"
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`
export const BITQUERY_API = 'https://graphql.bitquery.io'

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction'

// export const INFO_CLIENT = 'https://bsc.streamingfast.io/subgraphs/name/pancakeswap/exchange-v2'
// export const BLOCKS_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/blocks'
// export const INFO_CLIENT = 'https://graph-qs.tanglesea.com/subgraphs/name/shimmersea/fantom-dex'
// export const BLOCKS_CLIENT = 'https://graph-qs.tanglesea.com/subgraphs/name/shimmersea/fantom-blocks'

export const GRAPH_API_NFTMARKET = "https://graph-qs.tanglesea.com/subgraphs/name/shimmersea/fantom-nft-market"


export const API_ENDPOINT = 'https://test-api.shimmersea.finance'

export const API_URL=`${import.meta.env.VITE_API}`

export const GRAPHQL_ENDPOINTS = {
  // [CHAIN_ID.FANTOM_TESTNET] : {
  //   blocksInfoUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_BLOCKS_INFO_URL,
  //   metropolisV1InfoUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_METROPOLIS_V1_INFO_URL,
  //   // metropolisV21InfoUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_METROPOLIS_V21_INFO_URL,
  //   metropolisV2VaultUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_METROPOLIS_V2_VAULT_URL,
  //   candleInfoUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_CANDLE_INFO_URL,
  //   metropolisLimitOrdersUrl: import.meta.env.VITE_FANTOM_TESTNET_GRAPHQL_METROPOLIS_V2_LIMIT_ORDERS_URL
  // },
  [CHAIN_ID.FANTOM] : {
    blocksInfoUrl: import.meta.env.VITE_FANTOM_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_FANTOM_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_FANTOM_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: import.meta.env.VITE_FANTOM_GRAPHQL_METROPOLIS_V2_VAULT_URL,
    candleInfoUrl: import.meta.env.VITE_FANTOM_GRAPHQL_CANDLE_INFO_URL,
    metropolisLimitOrdersUrl: import.meta.env.VITE_FANTOM_GRAPHQL_METROPOLIS_V2_LIMIT_ORDERS_URL
  },
  [CHAIN_ID.OPTIMISM] : {
    blocksInfoUrl: import.meta.env.VITE_OPTIMISM_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_OPTIMISM_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_OPTIMISM_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_OPTIMISM_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.POLYGON_ZKEVM] : {
    blocksInfoUrl: import.meta.env.VITE_POLYGON_ZKEVM_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_POLYGON_ZKEVM_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_POLYGON_ZKEVM_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_POLYGON_ZKEVM_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.ARBITRUM_ONE] : {
    blocksInfoUrl: import.meta.env.VITE_ARBITRUM_ONE_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_ARBITRUM_ONE_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_ARBITRUM_ONE_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_ARBITRUM_ONE_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.BASE] : {
    blocksInfoUrl: import.meta.env.VITE_BASE_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_BASE_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_BASE_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_BASE_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.SHIMMER] : {
    blocksInfoUrl: import.meta.env.VITE_SHIMMER_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_SHIMMER_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_SHIMMER_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_SHIMMER_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.IOTA] : {
    blocksInfoUrl: import.meta.env.VITE_IOTA_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_IOTA_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_IOTA_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_IOTA_GRAPHQL_CANDLE_INFO_URL,
  },
  [CHAIN_ID.SONIC] : {
    blocksInfoUrl: import.meta.env.VITE_SONIC_GRAPHQL_BLOCKS_INFO_URL,
    metropolisV1InfoUrl: import.meta.env.VITE_SONIC_GRAPHQL_METROPOLIS_V1_INFO_URL,
    metropolisV21InfoUrl: import.meta.env.VITE_SONIC_GRAPHQL_METROPOLIS_V21_INFO_URL,
    metropolisV2VaultUrl: null,
    candleInfoUrl: import.meta.env.VITE_SONIC_GRAPHQL_CANDLE_INFO_URL,
  },
}
